"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListingInspectionItemDtoInspectionTypeEnum = void 0;
exports.instanceOfListingInspectionItemDto = instanceOfListingInspectionItemDto;
exports.ListingInspectionItemDtoFromJSON = ListingInspectionItemDtoFromJSON;
exports.ListingInspectionItemDtoFromJSONTyped = ListingInspectionItemDtoFromJSONTyped;
exports.ListingInspectionItemDtoToJSON = ListingInspectionItemDtoToJSON;
exports.ListingInspectionItemDtoToJSONTyped = ListingInspectionItemDtoToJSONTyped;
var InspectionPreviewAttendeeDto_1 = require("./InspectionPreviewAttendeeDto");
/**
 * @export
 */
exports.ListingInspectionItemDtoInspectionTypeEnum = {
    Private: 'private',
    Open: 'open'
};
/**
 * Check if a given object implements the ListingInspectionItemDto interface.
 */
function instanceOfListingInspectionItemDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('inspectionStartTime' in value) || value['inspectionStartTime'] === undefined)
        return false;
    if (!('inspectionEndTime' in value) || value['inspectionEndTime'] === undefined)
        return false;
    if (!('inspectionType' in value) || value['inspectionType'] === undefined)
        return false;
    if (!('totalInspectionCount' in value) || value['totalInspectionCount'] === undefined)
        return false;
    if (!('preRegisteredCount' in value) || value['preRegisteredCount'] === undefined)
        return false;
    if (!('walkInCount' in value) || value['walkInCount'] === undefined)
        return false;
    if (!('attendedCount' in value) || value['attendedCount'] === undefined)
        return false;
    if (!('previewAttendees' in value) || value['previewAttendees'] === undefined)
        return false;
    if (!('isCancelled' in value) || value['isCancelled'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    return true;
}
function ListingInspectionItemDtoFromJSON(json) {
    return ListingInspectionItemDtoFromJSONTyped(json, false);
}
function ListingInspectionItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'inspectionStartTime': (new Date(json['inspectionStartTime'])),
        'inspectionEndTime': (new Date(json['inspectionEndTime'])),
        'inspectionType': json['inspectionType'],
        'totalInspectionCount': json['totalInspectionCount'],
        'preRegisteredCount': json['preRegisteredCount'],
        'walkInCount': json['walkInCount'],
        'attendedCount': json['attendedCount'],
        'previewAttendees': (json['previewAttendees'].map(InspectionPreviewAttendeeDto_1.InspectionPreviewAttendeeDtoFromJSON)),
        'isCancelled': json['isCancelled'],
        'cancellationReason': json['cancellationReason'] == null ? undefined : json['cancellationReason'],
        'createdAt': (new Date(json['createdAt'])),
    };
}
function ListingInspectionItemDtoToJSON(json) {
    return ListingInspectionItemDtoToJSONTyped(json, false);
}
function ListingInspectionItemDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'inspectionStartTime': value['inspectionStartTime'].toISOString(),
        'inspectionEndTime': value['inspectionEndTime'].toISOString(),
        'inspectionType': value['inspectionType'],
        'totalInspectionCount': value['totalInspectionCount'],
        'preRegisteredCount': value['preRegisteredCount'],
        'walkInCount': value['walkInCount'],
        'attendedCount': value['attendedCount'],
        'previewAttendees': (value['previewAttendees'].map(InspectionPreviewAttendeeDto_1.InspectionPreviewAttendeeDtoToJSON)),
        'isCancelled': value['isCancelled'],
        'cancellationReason': value['cancellationReason'],
        'createdAt': value['createdAt'].toISOString(),
    };
}
